import { CircularProgress, Box } from '@mui/material'

interface LoadingSpinnerProps {
  size?: number
  fullPage?: boolean
}

export function LoadingSpinner({ size = 40, fullPage = false }: LoadingSpinnerProps) {
  const spinner = <CircularProgress size={size} />

  if (fullPage) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        {spinner}
      </Box>
    )
  }

  return (
    <Box display="flex" justifyContent="center" alignItems="center" p={3}>
      {spinner}
    </Box>
  )
}
